import React from 'react';
import { HoverPopup, StyleObject } from './HoverPopup';
import { IoMdInformationCircle } from 'react-icons/io';
import { theme } from './style';

interface Props {
  text: string;
  width?: string;
  style?: StyleObject;
}
export const MoreInfo = ({ text, width = '267px', style }: Props) => {
  return (
    <HoverPopup
      hoverable={
        <IoMdInformationCircle
          color={theme.palette.gray60}
          style={{ display: 'block' }}
        />
      }
      position="above"
      popup={<>{text}</>}
      showtriangle
      width={width}
      style={style}
    />
  );
};
